module.exports = __webpack_public_path__ + "img/search-outline.dd817435.svg";